<template>
  <div>
    <qg-cell-group title="navigator-导航栏">
      <qg-cell title="个人业绩" is-link @click="goPersonalAchievement" />
      <qg-cell title="伙伴业绩" is-link @click="goPartnerAchievement" />
      <qg-cell title="旺铺分润账单" is-link @click="goProfitWPBill" />
      <qg-cell title="普通分润账单" is-link @click="goProfitPTBill" />
      <qg-cell
        title="普通分润账单-改"
        is-link
        @click="goProfitPTBillRevision"
      />
      <qg-cell title="发票详情" is-link @click="goInvoice" />
      <qg-cell title="伙伴详情" is-link to="partner-detail" />
      <qg-cell title="商户详情" is-link to="merchant-detail" />
      <qg-cell title="个人业绩-改" is-link to="personal-achievement-revision" />
      <qg-cell title="伙伴业绩-改" is-link to="partner-achievement-revision" />
      <qg-cell title="我的增量奖" is-link to="incremental-award" />
      <div class="result-content">
        返回内容：
        <br />
        {{ result }}
      </div>
      <!-- <qg-cell title="测试" is-link @click="jiemi" /> -->
      <qg-cell title="设置导航栏标题" is-link @click="setNavigationBarTitle" />
      <qg-cell title="显示导航栏" is-link @click="showNavigationBar" />
      <qg-cell title="隐藏导航栏" is-link @click="hiddenNavigationBar" />
      <qg-cell title="显示状态栏" is-link @click="showStatusBar" />
      <qg-cell title="隐藏状态栏" is-link @click="hiddenStatusBar" />
      <qg-cell title="隐藏返回按钮" is-link @click="hiddenBackBtn" />
      <qg-cell title="拦截系统返回" is-link @click="hookSysBack" />
      <qg-cell title="拦截左侧按钮返回" is-link @click="hookBackBtn" />
      <qg-cell title="设置右侧按钮" is-link @click="setNavRightBtn" />
      <qg-cell title="设置左侧按钮" is-link @click="setLeftBtn" />
      <qg-cell title="隐藏右侧按钮" is-link @click="hiddenRightBtn" />
      <qg-cell title="设置右侧多个操作按钮" is-link @click="setRightMenu" />
    </qg-cell-group>
    <qg-cell-group title="utils-媒体">
      <qg-cell title="扫描二维码" is-link @click="scan" />
      <qg-cell title="选择图片" is-link @click="chooseImage" />
      <qg-cell title="选择文件" is-link @click="chooseMessageFile" />
    </qg-cell-group>
    <qg-cell-group title="page-页面">
      <qg-cell title="打开app页面" is-link @click="goAppView" />
      <qg-cell title="打开原生app页面" is-link @click="openOriginalView" />
      <qg-cell title="打开新页面" is-link @click="openWebView" />
      <qg-cell title="关闭页面" is-link @click="closeWebView" />
      <qg-cell title="重载页面" is-link @click="reload" />
      <qg-cell title="获取照片页" is-link @click="getPic" />
    </qg-cell-group>
    <qg-cell-group title="device-系统信息">
      <qg-cell title="设置横屏" is-link @click="setOrientation" />
      <qg-cell title="获取设备微信ID" is-link @click="getDeviceId" />
      <qg-cell title="获取代理商信息" is-link @click="getVendorInfo" />
      <qg-cell title="获取网络状态信息" is-link @click="getNetWorkInfo" />
      <qg-cell title="拨打电话" is-link @click="callPhone" />
      <qg-cell title="发送短信" is-link @click="sendMsg" />
      <qg-cell title="触发震动" is-link @click="vibrate" />
    </qg-cell-group>
    <qg-cell-group title="runtime-工具类">
      <qg-cell title="打开第三方APP" is-link @click="launchApp" />
      <qg-cell
        :title="'获取app版本号 ' + version"
        is-link
        @click="getAppVersion"
      />
      <qg-cell
        :title="'获取sdk版本号 ' + sdkVersion"
        is-link
        @click="getSdkVersion"
      />
      <qg-cell :title="cacheTxt" is-link @click="clearCache" />
      <qg-cell :title="locationTxt" is-link @click="getGeoLocation" />
      <qg-cell title="复制到剪切板" is-link @click="clipboard" />
      <qg-cell title="外部浏览器打开url" is-link @click="openUrl" />
    </qg-cell-group>
  </div>
</template>
<script>
import { platformAgent } from '@/utils/utils'
import { Cell, CellGroup, Toast } from 'vant'
export default {
  data() {
    return {
      cacheTxt: '清除缓存',
      locationTxt: '获取地理位置',
      version: '',
      sdkVersion: '',
      result: ''
    }
  },
  components: {
    QgCell: Cell,
    QgCellGroup: CellGroup
  },
  created() {},
  methods: {
    goAppView() {
      let params = {}
      if (platformAgent() == 'android') {
        params = {
          hostName: 'com.worth.ydfpartner.ui.mine.MyAddressListAct',
          bundle1: 1001
        }
      } else if (platformAgent() == 'ios') {
        params = {
          hostName: 'WSUserMyAddressViewController',
          isFromMachineBuy: 1
        }
      }
      SyHybridSdk.openOriActivity({
        params: params,
        success: res => {
          if (res) {
            alert(JSON.stringify(res))
          }
        }
      })
    },
    goPersonalProfit() {
      window.location.href = '/personal-profit'
    },
    goPersonalAchievement() {
      this.$router.push({
        name: 'personal-achievement'
      })
    },
    goPartnerAchievement() {
      this.$router.push({
        name: 'partner-achievement'
      })
    },
    goProfitWPBill() {
      this.$router.push({
        name: 'profit-bill-wp'
      })
    },
    goProfitPTBill() {
      this.$router.push({
        name: 'profit-bill-general'
      })
    },
    goProfitPTBillRevision() {
      this.$router.push({
        name: 'profit-bill-general-revision'
      })
    },
    getPic() {
      this.$router.push({
        name: 'upload-file'
      })
    },
    goInvoice() {
      this.$router.push({
        path: '/invoice-detail'
      })
    },
    // 外部浏览器打开url
    openUrl() {
      SyHybridSdk.openUrl({
        params: {
          url: 'https://www.baidu.com'
        },
        success: res => {}
      })
    },
    // 复制到剪切板
    clipboard() {
      SyHybridSdk.clipboard({
        params: {
          content: '这是复制的内容'
        },
        success: res => {}
      })
    },
    // 获取地理位置
    getGeoLocation() {
      let _this = this
      SyHybridSdk.getGeoLocation({
        params: {},
        success: res => {
          this.locationTxt = '获取地理位置成功'
        },
        fail: err => {
          this.locationTxt = '获取地理位置失败'
        }
      })
    },
    // 清除缓存
    clearCache() {
      SyHybridSdk.clearCache({
        params: {},
        success: res => {
          this.cacheTxt = '清除成功'
        }
      })
    },
    // 获取app版本号
    getAppVersion() {
      SyHybridSdk.getAppVersion({
        params: {},
        success: res => {
          this.version = res.version || ''
        }
      })
    },
    // 获取sdk版本号
    getSdkVersion() {
      SyHybridSdk.getHybridVersion({
        params: {},
        success: res => {
          alert(JSON.stringify(res))
          this.sdkVersion = res.version || ''
        }
      })
    },
    // 打开第三方APP
    launchApp() {
      SyHybridSdk.launchApp({
        params: {
          scheme: 'taobao://'
        },
        success: res => {
          alert('ok: ' + res)
        },
        fail: err => {
          alert('err: ' + err)
        }
      })
    },
    // 触发震动
    vibrate() {
      SyHybridSdk.vibrate({
        params: {},
        success: res => {}
      })
    },
    // 发送短信
    sendMsg() {
      SyHybridSdk.sendMsg({
        params: {
          phone: '18916752088',
          content: '这是测试发送信息'
        },
        success: res => {}
      })
    },
    // 拨打电话
    callPhone() {
      SyHybridSdk.callPhone({
        params: {
          phone: '18916752088'
        },
        success: res => {}
      })
    },
    // 获取网络状态信息
    getNetWorkInfo() {
      SyHybridSdk.getNetWorkInfo({
        params: {
          orient: 'horizontal'
        },
        success: res => {
          alert(JSON.stringify(res))
        },
        fail: err => {
          alert('error')
        }
      })
    },
    // 获取代理商信息
    getVendorInfo() {
      SyHybridSdk.getVendorInfo({
        params: {
          orient: 'horizontal'
        },
        success: res => {
          alert(JSON.stringify(res))
        },
        fail: err => {
          alert('error')
        }
      })
    },
    // 获取设备微信ID
    getDeviceId() {
      SyHybridSdk.getDeviceId({
        params: {
          orient: 'horizontal'
        },
        success: res => {
          alert(JSON.stringify(res))
        },
        fail: err => {
          alert('error')
        }
      })
    },
    // 设置横屏
    setOrientation() {
      SyHybridSdk.setOrientation({
        params: {
          orient: 'horizontal'
        },
        success: res => {}
      })
    },
    // 重载页面
    reload() {
      SyHybridSdk.reload({
        params: {},
        success: res => {}
      })
    },
    // 关闭页面
    closeWebView() {
      SyHybridSdk.closeWebView({
        params: {},
        success: res => {}
      })
    },
    // 打开新页面
    openWebView() {
      SyHybridSdk.openWebView({
        params: {
          url: 'https://www.baidu.com/',
          style: '-1',
          orientation: '2'
        },
        success: res => {}
      })
    },
    // 打开原生app页面
    openOriginalView() {
      let params = {}
      if (platformAgent() == 'android') {
        params = {
          hostName: 'com.worth.ydfpartner.ui.mine.MyAddressListAct',
          bundle1: 1001
        }
      } else if (platformAgent() == 'ios') {
        params = {
          hostName: 'WSUserMyAddressViewController',
          isFromMachineBuy: 1
        }
      }
      SyHybridSdk.openOriActivity({
        params: params,
        success: res => {
          if (res) {
            alert(JSON.stringify(res))
          }
        }
      })
    },
    // 设置右侧多个操作按钮
    setRightMenu() {
      SyHybridSdk.setRightMenu({
        params: [
          {
            label: '测试1',
            imageUrl:
              'https://syfrontweb.oss-cn-hangzhou.aliyuncs.com/wechat/small-mina/icon-account.png',
            func() {
              // 调用成功执行的function
              alert('测试1')
            }
          },
          {
            label: '测试2',
            imageUrl: '',
            func() {
              // 调用成功执行的function
              alert('测试2')
            }
          }
        ],
        success: res => {}
      })
    },
    // 隐藏右侧按钮
    hiddenRightBtn() {
      SyHybridSdk.setNavRightBtn({
        params: {
          isShow: 0,
          label: '',
          func() {}
        },
        success: res => {}
      })
    },
    // 设置左侧按钮
    setLeftBtn() {
      SyHybridSdk.setLeftBtn({
        params: {
          isShow: 1,
          imageUrl:
            'https://syfrontweb.oss-cn-hangzhou.aliyuncs.com/wechat/small-mina/icon-account.png',
          func() {
            alert('左侧')
          }
        },
        success: res => {}
      })
    },
    // 设置右侧按钮
    setNavRightBtn() {
      SyHybridSdk.setNavRightBtn({
        params: {
          isShow: 1,
          label: '分享',
          func() {
            alert('右侧')
          }
        },
        success: res => {}
      })
    },
    // 拦截左侧按钮返回
    hookBackBtn() {
      SyHybridSdk.hookBackBtn({
        params: {},
        success: res => {}
      })
    },
    // 拦截系统返回
    hookSysBack() {
      SyHybridSdk.hookSysBack({
        params: {
          canback: 1
        },
        success: res => {
          alert('back')
        }
      })
    },
    // 隐藏返回按钮
    hiddenBackBtn() {
      SyHybridSdk.hiddenBackBtn({
        params: {},
        success: res => {}
      })
    },
    // 隐藏状态栏
    hiddenStatusBar() {
      SyHybridSdk.hiddenStatusBar({
        params: {},
        success: res => {}
      })
    },
    // 显示状态栏
    showStatusBar() {
      SyHybridSdk.showStatusBar({
        params: {},
        success: res => {}
      })
    },
    // 隐藏导航栏
    hiddenNavigationBar() {
      SyHybridSdk.hiddenNavigationBar({
        params: {},
        success: res => {}
      })
    },
    // 显示导航栏
    showNavigationBar() {
      SyHybridSdk.showNavigationBar({
        params: {},
        success: res => {}
      })
    },
    // 设置导航栏标题
    setNavigationBarTitle() {
      SyHybridSdk.setNavigationBarTitle({
        params: {
          title: '前端自定义'
        },
        success: res => {
          alert('ok')
        }
      })
    },
    // 相机扫描
    scan() {
      SyHybridSdk.scan({
        success: res => {
          alert(JSON.stringify(res))
        }
      })
    },
    // 选择图片
    chooseImage() {
      SyHybridSdk.chooseImage({
        success: res => {
          alert(JSON.stringify(res))
        }
      })
    },
    // 选择文件
    chooseMessageFile() {
      SyHybridSdk.chooseMessageFile({
        success: res => {
          alert(JSON.stringify(res))
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.result-content {
  word-wrap: break-word;
  word-break: normal;
}
</style>
